import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { noop } from '@cd/utils';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Collapse from '@mui/material/Collapse';
import { CenterProgress } from '../component/CenterProgress';
import { useHistory, withRouter } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useFunctionAsState } from '../utilsReact';
import { checkIfGroup } from './HistoryListUtils';
import { Divider } from '@mui/material';

const listItemSx = theme => ({
	cursor: 'not-allowed',
	padding: theme.spacing(1, 0)
});
const listItemClickableSx = {
	cursor: 'pointer'
};
const nestedSx = theme => ({
	paddingLeft: theme.spacing(4)
});
const canClickSx = {
	cursor: 'pointer'
};
const totalSx = {
	fontWeight: 700
};
const totalRowSx = {
	borderBottom: '1px solid grey'
};

const enhance = withRouter;

const HistoryListRow = ({
	isGroup,
	open,
	pushID,
	onClick = noop,
	onSelected = noop,
	item = {},
	onIcon,
	onPrimaryText,
	onSecondaryText,
	onActionCmp,
	index
}) => (
	<ListItem
		onClick={
			item.id > 0
				? () => pushID(item.id, index)
				: () => onClick(index, item)
		}
		sx={[
			listItemSx,
			(!!item.id || onClick) && listItemClickableSx,
			(item.error_details || isGroup) && canClickSx
		]}
		key={index}>
		<ListItemIcon
			onClick={e => {
				e.stopPropagation();

				onSelected(item, isGroup);
			}}>
			{onIcon(item, isGroup)}
		</ListItemIcon>
		<ListItemText
			primary={onPrimaryText(item, isGroup, index)}
			secondary={onSecondaryText(item, isGroup, index)}
		/>
		<Typography variant="body2">{onActionCmp(item, isGroup)}</Typography>
		{isGroup && (open ? <ExpandLess /> : <ExpandMore />)}
	</ListItem>
);

const HistoryTotalRow = ({ item = {}, index }) => (
	<>
		<Divider sx={{ mt: '16px' }} />
		<ListItem
			sx={listItemSx}
			key={index}>
			<ListItemIcon>TOTAL</ListItemIcon>
			<ListItemText primary="" secondary="" />
			<Typography variant="body1" style={{ fontWeight: 'bold' }}>
				<span>${item.total}</span>
			</Typography>
		</ListItem>
	</>
);

function getFinalData2(isGroup, { filteredData, selectedData, data }) {
	const finalData =
		filteredData !== null
			? filteredData
			: selectedData !== null
			? selectedData
			: data;

	return isGroup
		? R.compose(R.reject(R.equals(undefined)), R.chain)(R.head, finalData)
		: finalData;
}

const HistoryList = ({
	data = [],
	location,
	title,
	total,
	FilterCmp,
	SelectCmp,
	ActionCmp,
	noTotalRow,
	listStyle,
	onDataLoaded = noop,
	onIcon = noop,
	onClick = noop,
	onSelected = noop,
	onPrimaryText = noop,
	onSecondaryText = noop,
	onActionCmp = noop
}) => {
	const [baseURL] = useState(location.pathname);
	const [openObj, setOpenObj] = useState({});

	const history = useHistory();
	const [filteredData, setFilterData] = useState(null);
	const [selectedData, setSelectedData] = useState(null);
	const [finalData2, setFinalData2] = useState(null);
	const [onSelectCmpFn, registerOnSelect] = useFunctionAsState(noop);
	const [onIconCmpFn, registerOnIcon] = useFunctionAsState(noop);
	const FinalFilterCmp =
		FilterCmp &&
		React.cloneElement(FilterCmp, {
			data: selectedData || data,
			setFilterData
		});

	const FinalSelectCmp =
		SelectCmp &&
		React.cloneElement(SelectCmp, {
			data,
			setSelectedData,
			registerOnSelect,
			registerOnIcon
		});

	const isGroup = checkIfGroup(data);
	console.log('isgroup', isGroup);

	useEffect(() => {
		onDataLoaded(data);
		setSelectedData(null);
		setFilterData(null);
		setFinalData2(
			getFinalData2(isGroup, {
				data,
				filteredData: null,
				selectedData: null
			})
		);
	}, [data]);

	useEffect(() => {
		setSelectedData(null);
		setFinalData2(
			getFinalData2(isGroup, {
				data,
				filteredData,
				selectedData: null
			})
		);
	}, [filteredData]);

	useEffect(() => {
		setFinalData2(
			getFinalData2(isGroup, {
				data,
				filteredData,
				selectedData
			})
		);
	}, [selectedData]);

	function _onSelected(item) {
		onSelectCmpFn && onSelectCmpFn(item);
		onSelected(item);
	}
	function _onIcon(item, isGroup) {
		console.log('tiem !', item, isGroup);

		return (
			(onIconCmpFn && R.isNil(item.icon) && onIconCmpFn(item)) ||
			onIcon(item, isGroup)
		);
	}

	function onOpenClose(index) {
		setOpenObj(R.assoc(index, openObj[index] ? false : true, openObj));
	}
	function pushID(id) {
		history.push(`${baseURL}/${id}`, data.find(R.propEq('id', id)));
	}

	return (
		(finalData2 && (
			<>
				<Typography variant="h6">{title}</Typography>
				{FinalFilterCmp}
				{FinalSelectCmp}
				<List disablePadding css={listStyle}>
					<ListItem sx={[listItemSx, totalRowSx]}>
						<ListItemText
							primary="Count"
							sx={totalSx}
						/>
						<Typography
							variant="subtitle1"
							sx={totalSx}>
							{finalData2.length}
						</Typography>
					</ListItem>

					{finalData2.map((item, index) => {
						const finalData3 =
							isGroup && index < data.length
								? R.tail(data[index])
								: [];
						return (
							<React.Fragment key={index}>
								<HistoryListRow
									onSelected={_onSelected}
									isGroup={isGroup}
									open={openObj[index]}
									pushID={pushID}
									onClick={
										onClick !== noop ? onClick : onOpenClose
									}
									item={item}
									onIcon={_onIcon}
									onPrimaryText={onPrimaryText}
									onSecondaryText={onSecondaryText}
									onActionCmp={onActionCmp}
									index={index}
								/>
								{isGroup && (
									<Collapse
										in={openObj[index]}
										timeout="auto"
										unmountOnExit>
										<List
											key={index}
											sx={nestedSx}>
											{finalData3.map((item, index) => (
												<HistoryListRow
													key={index}
													onSelected={onSelected}
													pushID={pushID}
													item={item}
													onIcon={onIcon}
													onPrimaryText={
														onPrimaryText
													}
													onSecondaryText={
														onSecondaryText
													}
													onActionCmp={onActionCmp}
													index={index}
												/>
											))}
										</List>
									</Collapse>
								)}
								{!noTotalRow &&
									index === finalData2.length - 1 && (
										<HistoryTotalRow
											item={item}
											index={index}
										/>
									)}
							</React.Fragment>
						);
					})}
				</List>
			</>
		)) || <CenterProgress />
	);
};

export default enhance(HistoryList);
